import A11yDialog from 'a11y-dialog';
import { $, $$ } from '../lib/domUtils';

const dialogElement = $('#dialog');
const dialogContent = $('#dialog-content');
const dialog = new A11yDialog(dialogElement, '#app');

// Prevent the page from scrolling when the dialo is open
dialog.on('show', () => {
  document.documentElement.style.overflow = 'hidden';
});
dialog.on('hide', () => {
  document.documentElement.style.overflow = null;
});

$$('[data-modal-show]').forEach(link => {
  link.addEventListener('click', event => {
    const target = document.getElementById(link.getAttribute('data-modal-show'));
    if (target) {
      dialogContent.innerHTML = target.innerHTML;
      dialog.show();
    }
    event.preventDefault();
  });
});
